const SDGData = [
  {
    id: '1',
    name: 'NO_POVERTY',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/01-no-poverty.png',
  },
  {
    id: '2',
    name: 'ZERO_HUNGER',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/02-zero-hunger.png',
  },
  {
    id: '3',
    name: 'Good Health and Well-being',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/03-good-health-and-well-being.png',
  },
  {
    id: '4',
    name: 'Quality Education',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/04-quality-education.png',
  },
  {
    id: '5',
    name: 'Gender Equality',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/05-gender-equality.png',
  },
  {
    id: '6',
    name: 'Clean Water and Sanitation',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/06-clean-water-and-sanitation.png',
  },
  {
    id: '7',
    name: 'Affordable and Clean Energy',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/07-affordable-and-clean-energy.png',
  },
  {
    id: '8',
    name: 'Decent Work and Economic Growth',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/08-decent-work-and-economic-growth.png',
  },
  {
    id: '9',
    name: 'Industry, Innovation and Infrastructure',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/09-industry-innovation-and-infrastructure.png',
  },
  {
    id: '10',
    name: 'Reduced Inequalities',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/10-reduced-inequalities.png',
  },
  {
    id: '11',
    name: 'Sustainable Cities and Communities',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/11-sustainable-cities-and-communities.png',
  },
  {
    id: '12',
    name: 'Responsible Consumption and Production',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/12-responsible-consumption-and-production.png',
  },
  {
    id: '13',
    name: 'Climate Action',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/13-climate-action.png',
  },
  {
    id: '14',
    name: 'Life Below Water',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/14-life-below-water.png',
  },
  {
    id: '15',
    name: 'Life on Land',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/15-life-on-land.png',
  },
  {
    id: '16',
    name: 'Peace, Justice and Strong Institutions',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/16-peace-justice-and-strong-institutions.png',
  },
  {
    id: '17',
    name: 'Partnership for the Goals',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/17-partnerships-for-the-goals.png',
  },
];

export default SDGData;

export const SDGAllItems = [
  {
    id: 'NO_POVERTY',
    nr: 1,
    label: 'No Poverty',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/01-no-poverty.png',
  },
  {
    id: 'ZERO_HUNGER',
    nr: 2,
    label: 'Zero Hunger',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/02-zero-hunger.png',
  },
  {
    id: 'GOOD_HEALTH_AND_WELL_BEING',
    nr: 3,
    label: 'Good Health and Well-being',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/03-good-health-and-well-being.png',
  },
  {
    id: 'QUALITY_EDUCATION',
    nr: 4,
    label: 'Quality Education',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/04-quality-education.png',
  },
  {
    id: 'GENDER_EQUALITY',
    nr: 5,
    label: 'Gender Equality',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/05-gender-equality.png',
  },
  {
    id: 'CLEAN_WATER_AND_SANITATION',
    nr: 6,
    label: 'Clean Water and Sanitation',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/06-clean-water-and-sanitation.png',
  },
  {
    id: 'AFFORDABLE_AND_CLEAN_ENERGY',
    nr: 7,
    label: 'Affordable and Clean Energy',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/07-affordable-and-clean-energy.png',
  },
  {
    id: 'DECENT_WORK_AND_ECONOMIC_GROWTH',
    nr: 8,
    label: 'Decent Work and Economic Growth',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/08-decent-work-and-economic-growth.png',
  },
  {
    id: 'INDUSTRY_INNOVATION_AND_INFRASTRUCTURE',
    nr: 9,
    label: 'Industry, Innovation and Infrastructure',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/09-industry-innovation-and-infrastructure.png',
  },
  {
    id: 'REDUCED_INEQUALITIES',
    nr: 10,
    label: 'Reduced Inequalities',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/10-reduced-inequalities.png',
  },
  {
    id: 'SUSTAINABLE_CITIES_AND_COMMUNITIES',
    nr: 11,
    label: 'Sustainable Cities and Communities',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/11-sustainable-cities-and-communities.png',
  },
  {
    id: 'RESPONSIBLE_CONSUMPTION_AND_PRODUCTION',
    nr: 12,
    label: 'Responsible Consumption and Production',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/12-responsible-consumption-and-production.png',
  },
  {
    id: 'CLIMATE_ACTION',
    nr: 13,
    label: 'Climate Action',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/13-climate-action.png',
  },
  {
    id: 'LIFE_BELOW_WATER',
    nr: 14,
    label: 'Life Below Water',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/14-life-below-water.png',
  },
  {
    id: 'LIFE_ON_LAND',
    nr: 15,
    label: 'Life on Land',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/15-life-on-land.png',
  },
  {
    id: 'PEACE_JUSTICE_AND_STRONG_INSTITUTIONS',
    nr: 16,
    label: 'Peace, Justice and Strong Institutions',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/16-peace-justice-and-strong-institutions.png',
  },
  {
    id: 'PARTNERSHIPS_FOR_THE_GOALS',
    nr: 17,
    label: 'Partnerships for the Goals',
    imagePath:
      'https://iex-testing-bucket.fra1.cdn.digitaloceanspaces.com/assets/img/sdg/17-partnerships-for-the-goals.png',
  },
];
